// 获取产品列表
export const GETPRODUCTLIST = '/tbRunwelProduct/queryAllRunwelProduct';

// 获取服务列表
export const GETSERVERLIST = '/tbRunwelService/getAll';

// 获取新闻列表
export const GETNEWSLIST = '/tbNews/getAll';

// 通过id获取单个产品
export const GETPRODUCTINFOBYID = '/tbRunwelProduct/queryById';

// 提交咨询信息
export const SUBMITCONSULTINFO = '/tbConsultingService/add';

// 通过服务id获取单个服务
export const GETSERVERINFOBYID = '/tbRunwelService/queryById';

// 通过新闻id获取单个新闻
export const GETNEWSINFOBYID = '/tbNews/queryById';

// 获取关于我们相关信息
export const GETABOUTUSINFO = '/tbAboutUs/get';

// 获取图片库信息
export const GETPICTUREINFO = '/tbImages/getImages';

// 访问量+1
export const ADD_VISIT = '/tbVisitsInfo/add';


// 获取招聘信息
export const GET_ALL_JOIN = '/tbJoin/getAll';

//根据id获取单个招聘信息
export const QUERY_JOIN_BY_ID = "/tbJoin/queryById";